import { Box, Skeleton } from '@mui/material';
import Grid from '@mui/material/Grid2';

export function TeamMemberContentSkeleton() {
  return (
    <Grid container spacing='26px'>
      {[1, 2, 3, 4].map((i) => (
        <Grid size={12} key={i}>
          <Skeleton variant='text' width={60} height={20} sx={{ mb: 1 }} />
          <Skeleton variant='rectangular' height={56} sx={{ borderRadius: 1 }} />
        </Grid>
      ))}

      {/* Locations skeleton */}
      <Grid size={12}>
        <Skeleton variant='text' width={80} height={20} sx={{ mb: 1 }} />

        <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', mt: 1 }}>
          {[...Array(4)].map((_, i) => (
            <Box key={i} display='flex' alignItems='center' gap={1}>
              <Skeleton variant='rectangular' width={18} height={18} />
              <Skeleton variant='text' width={80} height={20} />
            </Box>
          ))}
        </Box>
      </Grid>
    </Grid>
  );
}

export function TeamMemberFooterSkeleton() {
  return (
    <>
      <Skeleton variant='rectangular' width={80} height={40} />
      <Skeleton variant='rectangular' width={80} height={40} />
    </>
  );
}
